module.exports = __webpack_public_path__ + "img/Masonry1.72bf0d85.jpeg";